export const usersTableHead = [
    {
        name:'',
        sortable: false
    },
    {
        name: 'Name',
        sortable: true,
        order: 'fname'
    },
    {
        name: 'Title',
        sortable: true,
        order: 'jobTitle'
    },
    {
        name: 'Company',
        sortable: true,
        order: 'company'
    },
    {
        name: 'Street',
        sortable: true,
        order: 'street'
    },
    {
        name: 'City',
        sortable: true,
        order: 'city'
    },
    {
        name: 'Zip',
        sortable: true,
        order: 'zip'
    },
    {
        name: 'Country',
        sortable: true,
        order: 'country'
    },
    {
        name: 'Email',
        sortable: true,
        order: 'email'
    },
    {
        name: 'Phone',
        sortable: true,
        order: 'phoneNumber'
    },
    {
        name: 'Type',
        sortable: true,
        order: 'type'
    },
    {
        name: 'Checkbox',
        sortable: false,
    },
];